import NiceModal from '@ebay/nice-modal-react';
import { DefaultStyleProvider } from '@frontapp/ui-kit';
import React, { useCallback } from 'react';
import ReactDOM from 'react-dom/client';
import NotificationsSystem, {
  atalhoTheme,
  FadeTransition,
  NotificationsProvider,
  setUpNotifications,
  useNotifications,
} from 'reapop';
import { useLocalStorage } from 'usehooks-ts';
import App from './App';
import Login from './Login';
import './index.css';
import { FrontContextProvider } from './utils/front';

setUpNotifications({
  defaultProps: {
    position: 'top-center',
    dismissible: true,
    dismissAfter: 3000,
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

function Root() {
  const [token, setToken] = useLocalStorage('customerToken', '');
  const { notifications, dismissNotification } = useNotifications();

  const handleLogout = useCallback(() => setToken(''), []);

  return (
    <>
      <NotificationsSystem
        notifications={notifications}
        dismissNotification={(id) => dismissNotification(id)}
        components={{ Transition: FadeTransition }}
        theme={atalhoTheme}
      />
      {token ? <App onLogout={handleLogout} /> : <Login onToken={setToken} />}
    </>
  );
}

root.render(
  <React.StrictMode>
    <NotificationsProvider>
      <NiceModal.Provider>
        <FrontContextProvider>
          <DefaultStyleProvider>
            <Root />
          </DefaultStyleProvider>
        </FrontContextProvider>
      </NiceModal.Provider>
    </NotificationsProvider>
  </React.StrictMode>,
);
